import React, { Component } from 'react';
import 'cropperjs/dist/cropper.css';
import Cropper from 'react-cropper';
import MediaBrowserService from './mediaBrowser/MediaBrowserService';
import { valueForKeyPath as v, dataURLtoFile } from '../../../utils.jsx';

class ImageEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      originImageUrl: null,
      resultImageUrl: null,
      aspectRatio: 'NaN',
      rotationDegree: 45,
      resultModalVisible: false,
      resultImageFilename: '',
      isFetching: false,
      successfullyUploaded: false,
    };

    this.cropper = null;
  }

  onCropperReady = () => {
    const currentCanvasData = this.cropper.getCanvasData();
    this.cropper.setCanvasData({
      ...currentCanvasData,
      height: currentCanvasData.naturalHeight,
    });
  };

  crop = () => {
    this.setState({
      cropPreview: this.cropper.getCroppedCanvas().toDataURL(),
    });
  };

  onFileSelect = (uri, item) => {
    if (!v(item, 'type', '').match(/image\/.*/)) {
      alert('Súbor je má nesprávny formát!');
      return;
    }

    MediaBrowserService.closeMediaBrowser();

    const filenameWithoutFormat = item.name.match(/[^\.]*/)[0] || item.name ;
    
    
    this.setState({
      originImageUrl: `https://data.tvkosice.sk/cmdata/${item.uri}`,
      resultImageFilename: `${filenameWithoutFormat}-edited`
    });
  };

  rotate = value => {
    this.cropper.rotate(value);
  };

  setAspectRatio = (xVal, yVal) => {
    if (xVal === null && yVal === null) {
      this.setState({
        aspectRatio: 'NaN',
      });
      return;
    }

    this.setState({
      aspectRatio: {
        xVal,
        yVal,
      },
    });
  };

  handleRotationDegreeInput = e => {
    if (e.target.value <= 0 || e.target.value > 360) {
      return;
    }
    this.setState({
      rotationDegree: e.target.value,
    });
  };

  handleResultImageFilenameChange = e => {
    this.setState({
      resultImageFilename: e.target.value,
    });
  };

  openMediaManager = () => {
    MediaBrowserService.openMediaBrowser(
      this.onFileSelect,
      null,
      this.props.mediaManager,
      false,
    );
  };

  toggleResultModal = () => {
    this.setState({
      resultModalVisible: !this.state.resultModalVisible,
    });
  };

  convertImageToFormData = () => {
    const file = dataURLtoFile(
      this.state.resultImageUrl,
      this.state.resultImageFilename,
    );

    const binaryData = new FormData();
    binaryData.append(
      'media_file',
      file,
      `${this.state.resultImageFilename}.jpg`,
    );
    binaryData.append('path', null);

    file.preview = URL.createObjectURL(file);

    return binaryData;
  };

  uploadResultImage = () => {
    if (this.state.resultImageFilename === '') {
      alert('Zadajte meno upraveného obrázku!');
      return;
    }

    const binaryData = this.convertImageToFormData();

    this.setState(
      {
        isFetching: true,
      },
      async () => {
        try {
          await this.props.mediaManager.uploadFile(binaryData);
          this.toggleResultModal();
          this.setState(
            {
              isFetching: false,
              successfullyUploaded: true,
              originImageUrl: null,
            },
            () => setTimeout(this.resetStateToDefault, 5000),
          );
        } catch (e) {
          alert('Pri uploadovaní obrázku sa vyskytla chyba!');
        }
      },
    );
  };

  resetStateToDefault = () => {
    this.setState({
      originImageUrl: null,
      resultImageUrl: null,
      aspectRatio: 'NaN',
      rotationDegree: 45,
      resultModalVisible: false,
      resultImageFilename: '',
      isFetching: false,
      successfullyUploaded: false,
    });
  };

  render() {
    const {
      originImageUrl,
      aspectRatio,
      rotationDegree,
      resultImageUrl,
      resultModalVisible,
      resultImageFilename,
      isFetching,
      successfullyUploaded,
    } = this.state;

    if (!originImageUrl) {
      return (
        <div>
          {successfullyUploaded && (
            <div className="alert alert-success text-center">
              Obrázok bol úsepšne uložený ako{' '}
              <b>{this.state.resultImageFilename}.jpg</b>
            </div>
          )}
          <button
            className="btn btn-primary btn-block btn-sm"
            onClick={this.openMediaManager}
          >
            Vybrať obrázok
          </button>
        </div>
      );
    }
    return (
      <div id="image-editor" className="row">
        <div className="col-md-8" style={{ height: '500px' }}>
          <Cropper
            ref={cropper => {
              this.cropper = cropper;
            }}
            src={originImageUrl}
            aspectRatio={
              aspectRatio !== 'NaN'
                ? aspectRatio.xVal / aspectRatio.yVal
                : 'NaN'
            }
            ready={this.onCropperReady}
          />
        </div>
        <div className="col-md-4">
          <div className="panel panel-default">
            <div className="panel-heading">
              <strong> Možnosti</strong>
            </div>
            <div className="panel-body">
              <div className="form-group">
                <button
                  className="btn btn-small btn-success"
                  onClick={() => {
                    this.setState({
                      resultImageUrl: this.cropper
                        .getCroppedCanvas()
                        .toDataURL('image/jpeg'),
                    }, this.toggleResultModal);                    
                  }}
                  style={{ marginLeft: '5px' }}
                  title="Možnosť uloženia na server a stiahnutia obrázku"
                >
                  Uložiť zmeny
                </button>
                &nbsp;
                <button
                  className="btn btn-small btn-danger"
                  onClick={() => this.cropper.reset()}
                  title="Nastavenie rámca orezávania do pôvodného stavu"
                >
                  Pôvodný stav
                </button>
              </div>
            </div>
          </div>
          <div className="panel panel-default">
            <div className="panel-heading">
              <strong> Rotácia obrázku </strong>
            </div>
            <div className="panel-body">
              <div className="form-group" style={{ display: 'flex' }}>
                <button
                  onClick={() => this.rotate(-rotationDegree)}
                  className="btn btn-primary"
                  disabled={rotationDegree <= 0 || rotationDegree > 360}
                  title={`Rotácia obrázku vľavo o ${rotationDegree}°`}
                >
                  {rotationDegree} vľavo
                </button>
                &nbsp;
                <button
                  onClick={() => this.rotate(rotationDegree)}
                  className="btn btn-primary"
                  disabled={rotationDegree <= 0 || rotationDegree > 360}
                  title={`Rotácia obrázku vpravo o ${rotationDegree}°`}
                >
                  {rotationDegree} vpravo
                </button>
                &nbsp;
                <input
                  value={rotationDegree}
                  onChange={this.handleRotationDegreeInput}
                  className="form-control"
                  style={{ width: '75px' }}
                  type="number"
                />
                <span className="input-group-text">°</span>
              </div>
            </div>
          </div>
          <div className="panel panel-default">
            <div className="panel-heading">
              <strong> Pomer strán </strong>
            </div>
            <div className="panel-body">
              <div className="btn-group">
                <button
                  className="btn btn-primary btn-md"
                  type="button"
                  onClick={() => this.setAspectRatio(null, null)}
                  title="Voľne nastaviteľný rámec orezávania"
                >
                  Voľné
                </button>
                <button
                  className="btn btn-primary btn-md"
                  type="button"
                  onClick={() => this.setAspectRatio(16, 9)}
                  title="Rámec orezávania vo formáte 16:9"
                >
                  16:9
                </button>
                <button
                  className="btn btn-primary btn-md"
                  type="button"
                  onClick={() => this.setAspectRatio(4, 3)}
                  title="Rámec orezávania vo formáte 4:3"
                >
                  4:3
                </button>
                <button
                  className="btn btn-primary btn-md"
                  type="button"
                  onClick={() => this.setAspectRatio(1, 1)}
                  title="Rámec orezávania vo formáte 1:1"
                >
                  1:1
                </button>
              </div>
            </div>
          </div>
          <div className="panel panel-default">
            <div className="panel-heading">
              <strong>Zoom</strong>
            </div>
            <div className="panel-body">
              <div>
                <button
                  className="btn btn-small btn-primary"
                  onClick={() => this.cropper.zoom(0.1)}
                  title="Priblíženie pohľadu v rámci"
                >
                  Priblížiť
                </button>
                &nbsp;
                <button
                  className="btn btn-small btn-primary"
                  onClick={() => this.cropper.zoom(-0.1)}
                  title="Oddialenie pohľadu v rámci"
                >
                  Oddialiť
                </button>
              </div>
            </div>
          </div>
          <div className="panel panel-default">
            <div className="panel-heading">
              <strong>Vybrať iný obrázok</strong>
            </div>
            <div className="panel-body">
              <button
                className="btn btn-primary btn-block btn-sm"
                onClick={this.openMediaManager}
              >
                Otvoriť media browser
              </button>
            </div>
          </div>

          {resultModalVisible && (
            <ImageEditorResultModal
              onClose={this.toggleResultModal}
              resultImageUrl={resultImageUrl}
              onResultImageFilenameChange={this.handleResultImageFilenameChange}
              resultImageFilename={resultImageFilename}
              uploadResultImage={this.uploadResultImage}
              isFetching={isFetching}
            />
          )}
        </div>
      </div>
    );
  }
}

const ImageEditorResultModal = ({
  onClose,
  resultImageUrl,
  resultImageFilename,
  onResultImageFilenameChange,
  uploadResultImage,
  isFetching,
}) => {
  function resetInput() {
    setTimeout(() => {
      const myE = {
        target: {
          value: '',
        },
      };
      onResultImageFilenameChange(myE);
    }, 200);
  }

  return (
    <div>
      <div className="modal fade in" style={{ display: 'block' }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                aria-label="Close"
                onClick={onClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 className="modal-title">Uložiť obrázok</h4>
            </div>
            <div className="modal-body">
              {isFetching ? (
                <div className="loader" />
              ) : (
                <div>
                  <div>
                    <img className="img-fluid" src={resultImageUrl} alt="" />
                  </div>
                  <div style={{ marginTop: '20px' }}>
                    <label htmlFor="cropped-image-name">Názov obrázku</label>
                    <div className="form-group">
                      <input
                        type="text"
                        id="cropped-image-name"
                        className="form-control"
                        value={resultImageFilename}
                        onChange={onResultImageFilenameChange}
                        aria-label="Sizing example input"
                      />
                    </div>
                    <div>
                      <a
                        className="btn btn-small btn-success"
                        href={resultImageUrl}
                        onClick={uploadResultImage}
                      >
                        Uložiť na server
                      </a>
                      &nbsp;
                      <a
                        className="btn btn-small btn-primary"
                        href={resultImageUrl}
                        download={resultImageFilename}
                        onClick={resetInput}
                      >
                        Stiahnuť
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default ImageEditor;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ImageEditor.jsx